import React, {Component} from 'react';
import $ from 'jquery';
import FJConfig from "../../../../config/FJConfig";
import FJUtil from "../../../../util/FJUtil";
import InlineSVG from "react-inlinesvg";
import FJClearSearchIcon from "../../../../icon/close.svg";
import './FJAddTextArea.less';
import FJCoreUtil from "../../../../core/util/FJCoreUtil";

class FJAddTextArea extends Component {

  constructor(props) {
    super(props);
    this.state = {
      texts: [],
    };
    this.input = React.createRef();
  }

  componentDidMount() {
    FJCoreUtil.addEvent(this.input.current, "selectstart", (e) => {
      e.stopPropagation();
      return true;
    });
    this.input.current.addEventListener('dragstart', (e) => {
      e.preventDefault();
    });

  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    this.input.current.setSelectionRange(this._selectStart, this._selectStart);
  }

  _maxStringLength = FJConfig.maxTextInputCount;

  clear = () => {
    this.value(['']);
  };
  _createPlaceDiv = () => {
    if (!document.getElementById('c-text-place')) {
      let placeDiv = document.createElement('div');
      $(placeDiv).attr('id', 'c-text-place');
      $(placeDiv).css({
        opacity: 0,
        height: 0,
        display: 'inline-block',
        fontSize: '17px',
        zIndex: -1,
      });
      document.body.appendChild(placeDiv);
    }
  };
  value = (texts) => {
    if (typeof texts === 'undefined') {
      return this.state.texts;
    } else {
      let array = [];
      texts.forEach((item) => {
        array.push(item);
      });
      this.setState({
        texts: array,
      }, () => {
        this._autoFitHeight(array);
      });
    }
  };
  focus = () => {
    this.input.current.focus();
  };
  _onFocus = (e) => {
    e.stopPropagation();
    e.preventDefault();
    let value = this.input.current.value;
    this.input.current.value = '';
    this.input.current.value = value;
    $(this.input.current).select();
  };
  _onKeyDown = (e) => {
    if (this.props.disableEnter && e.keyCode === 13) {
      e.preventDefault();
    }
  };
  _onPaste = (e) => {

    let selectionStart = this.input.current.selectionStart;

    let curValueLength = this._getValueLength(e.target.value);
    let pasteValue = e.clipboardData.getData("text");
    let stayLength = this._maxStringLength + FJUtil.getSelectionLength(this.input.current) - curValueLength;
    stayLength = FJCoreUtil.valueOfInterval(stayLength, 0, this._getValueLength(pasteValue));
    let texts = pasteValue.split('\n');
    let curLength = 0;
    let results = [];
    for (let i = 0; i < texts.length; i++) {
      curLength = curLength + texts[i].length;
      if (curLength > stayLength) {
        let t = texts[i].slice(0, texts[i].length - (curLength - stayLength));
        results.push([t]);
        break;
      } else {
        results.push(texts[i]);
      }
    }
    let value = FJUtil.insertAtCursor(this.input.current, results.join('\n'));

    let anchorLength = selectionStart + stayLength;
    this.input.current.setSelectionRange(anchorLength, anchorLength);

    let data = value.split('\n');
    this.setState({
      texts: data,
    }, () => {
      this._autoFitHeight(data);
    });
    e.preventDefault();
  };

  _getValueLength = (value) => {
    let texts = value.split('\n');
    let length = 0;
    texts.forEach((text) => {
      length += text.length;
    });
    return length;
  };
  _dataChange = (e) => {
    if (this._getValueLength(e.target.value) > this._maxStringLength) {
      return;
    }
    let texts = e.target.value.split('\n');
    this.setState({
      texts: texts,
    }, () => {
      this._autoFitHeight(texts);
    });
  };
  _autoFitHeight = (texts) => {
    let inputWidth = 438;
    let line = 0;
    texts.forEach((text) => {
      let textWidth = FJUtil.getTextSize(text, {fontName:'inherit', fontSize: 17}).width + 2;
      line += Math.ceil(textWidth / inputWidth);
    });
    $(this.input.current).css({
      height: line * 26 + 'px'
    });
  };

  render() {
    let textLength = 0;
    let content = '';
    this.state.texts.forEach((item, index) => {
      textLength += item.length;
      content = content + item + ((index === this.state.texts.length - 1) ? '' : '\r');
    });
    this._selectStart = this.input.current && this.input.current.selectionStart;
    if (!this._lock) {
      content = content.replace(/ /g, ' ');
    }
    let isEmpty = content.length <= 0;
    return (
      <div className='c-add-text-area'>
                <textarea value={content}
                          ref={this.input}
                          placeholder={this.props.placeholder}
                          onChange={this._dataChange}
                          onKeyDown={this._onKeyDown}
                          onPaste={this._onPaste}
                          onFocus={this._onFocus}
                          onCompositionStart={() => {
                            this._lock = true;
                          }}
                          onCompositionEnd={() => {
                            this._lock = false;
                          }}
                          className='c-input'/>
        <div onClick={this.clear} className='c-clear-icon' style={{display: isEmpty ? 'none' : 'block'}}>
          <InlineSVG src={FJClearSearchIcon} element='div'/>
        </div>
        <span>{textLength + '/' + this._maxStringLength}</span>
        <i/>
      </div>
    );
  }

}

export default FJAddTextArea;
